import './UserHome.css';
import { UserMenu } from './UserMenu';
import AbstractImg from './abstract.png';
import { TopUserMenu } from './TopUserMenu';
import { SideMenu } from './SideMenu';
import { Link, useNavigate } from 'react-router-dom';
// eslint-disable-next-line no-unused-vars
import { useEffect, useState } from 'react';
// eslint-disable-next-line no-unused-vars
import { Logout } from '../../../App';
import { LoadingLayer } from '../../LoadingLayer';
import { useJwt } from 'react-jwt';

export const fetchProfileData = async (setProfile) => {
  try {
    const response = await fetch(
        'https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/profiles',
        {
          headers: {
            'user-token': localStorage.getItem('id_token'),
          },
        },
    );
    if (response.status === 401) {
      return response.status;
    }
    const data = await response.json();
    setProfile(data.Items[0]);
    return response.status;
  } catch (error) {
    return error;
  }
};

export const fetchRegisteredParticipation = async (setRegistration) => {
  try {
    const response = await fetch(
        'https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/register-participation/cicese',
        {
          headers: {
            'user-token': localStorage.getItem('id_token'),
          },
        },
    );
    if (response.status === 401) {
      return response.status;
    }
    const data = await response.json();
    setRegistration(data.Items[0]);
    return response.status;
  } catch (error) {
    return error;
  }
};



export const registerParticipation = async (setRegistration) => {
  try {
    const response = await fetch(
        'https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/register-participation/cicese',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'user-token': localStorage.getItem('id_token'),
          },
          body: JSON.stringify({}),
        },
    );
    const data = await response.json();
    console.log(data);
    setRegistration({});
  } catch (error) {
    console.error('Error:', error);
  }
};

export const fetchUserAbstractData = async (setAbstracts) => {
  try {
    const response = await fetch(
        'https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/abstract',
        {
          headers: {
            'user-token': localStorage.getItem('id_token'),
          },
        },
    );
    if (response.status === 401) {
      return response.status;
    }
    const data = await response.json();
    setAbstracts(data.Items);
    console.log(data.Items);
    return response.status;
  } catch (error) {
    return error;
  }
};

export const UserHome = () => {
  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate();
  const [profile, setProfile] = useState();
  const [abstracts, setAbstracts] = useState();

  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [registration, setRegistration] = useState();

  const access_token = localStorage.getItem('id_token');
  const { decodedToken } = useJwt(access_token);

  useEffect(() => {
    if (decodedToken) {
      if (decodedToken['cognito:groups'] && decodedToken['cognito:groups'].includes('admin')) {
        navigate('/admin');
      } else if (
          decodedToken['cognito:groups'] &&
          decodedToken['cognito:groups'].includes('coordniator')
      ) {
        navigate('/coordinator');
      } else if (
          decodedToken['cognito:groups'] &&
          decodedToken['cognito:groups'].includes('revisor') &&
          !decodedToken['cognito:groups'].includes('coordniator')
      ) {
        navigate('/revisor');
      }
    }
  }, [decodedToken]);


  useEffect(() => {
    setIsLoading(true);
    setLoadingMessage('Loading');
    fetchUserAbstractData(setAbstracts).then(() => {
      setIsLoading(false);
    });
    fetchProfileData(setProfile).then((responseStatus) => {
      console.log(responseStatus);
      if (responseStatus === 401) {
        Logout();
        navigate('/');
      }
      setIsLoading(false);
    });
    fetchRegisteredParticipation(setRegistration).then((responseStatus) => {
      console.log(responseStatus);
      if (responseStatus === 401) {
        Logout();
        navigate('/');
      }
      setIsLoading(false);
    });
  }, []);

  const logoutButton = () => {
    Logout();
    navigate('/');
  };

  return (
      <div className="snn-user-home-main-wrapper">
        <LoadingLayer isLoading={isLoading} action={loadingMessage} />
        <SideMenu />

        <div className="snn-user-home-main-content">
          <TopUserMenu name={profile ? profile.name : null} />
          <h1 className="snn-user-home-main-content-header hide-on-desktop">Welcome</h1>
          <h2 className="snn-user-home-main-content-large-semi hide-on-desktop">
            {profile ? profile.name : null}
          </h2>
          <div className="snn-user-home-main-content-grid">
            <div className="snn-user-home-main-content-submit-ribbon">
              <div className="snn-user-home-main-content-submit-ribbon-content">
                <p className="snn-user-home-main-content-small-text gold-text">
                  Participation without Abstract
                </p>
                {/*<p className="snn-user-home-main-content-large-semi">Submit now</p>*/}
                {/*<Link to="/abstracts/submit">*/}
                {/*  <div className="snn-user-home-main-content-submit-ribbon-button">*/}
                {/*    Submit now <span className="material-symbols-outlined">arrow_right_alt</span>*/}
                {/*  </div>*/}
                {/*</Link>*/}


                {registration ? <p className="snn-user-home-main-content-large-semi">Participation registered</p> :
                    <>
                      <p className="snn-user-home-main-content-large-semi">Register here</p>
                      <button onClick={() => registerParticipation(setRegistration)} className="snn-user-home-main-content-submit-ribbon-button">
                        Register assistance <span className="material-symbols-outlined">arrow_right_alt</span>
                      </button>
                    </>
                }

              </div>
              <div className="snn-ribbon-img-wrapper">
                <img src={AbstractImg} alt="abstract" />
              </div>
            </div>
            <section className="snn-user-home-section snn-user-home-abstract-section">
              <p className="snn-user-homa-main-content-text">Registered abstracts</p>
              <div className="snn-user-home-abstract-container">
                {abstracts ? (
                    abstracts.map((abstract) => (
                        <Link key={abstract.title} to={`/abstracts/${abstract.id}`}>
                          <div
                              className={
                                'snn-user-home-abstract-wrapper snn-user-home-abstract-bio'
                              }
                          >
                            <div className="snn-user-home-abstract-wrapper-text">
                              <p className="snn-user-home-main-content-small-text">{abstract.status}</p>
                              <p className="snn-user-home-main-content-large-semi">{abstract.title}</p>
                            </div>

                            {/*<div className="snn-user-home-wrapper-edit-button">*/}
                            {/*  <Link to={'/abstracts/edit/' + abstract.id}>*/}
                            {/*    <div className="snn-abstract-registered-card-button">*/}
                            {/*      Edit <span className="material-symbols-outlined">edit</span>*/}
                            {/*    </div>*/}
                            {/*  </Link>*/}
                            {/*</div>*/}
                          </div>
                        </Link>
                    ))
                ) : (
                    <p>No abstract registered yet</p>
                )}
              </div>
            </section>
          </div>
        </div>
        <UserMenu logoutButton={logoutButton} />
      </div>
  );
};